import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recent-visits',
  templateUrl: './recent-visits.component.html',
  styleUrls: ['./recent-visits.component.scss']
})
export class RecentVisitsComponent {
}
